<template>
  <div id="mask" v-show="false" >

  <div class="voucher-count">
    <!-- @close="VoucherClose" -->
    <el-dialog class="self-demo-dialog" center  width="90vw"    :visible.sync="testVoucherMobileShow"     @close="close"  append-to-body>
      <div class="voucher-title">《群侠传》测试充值</div>
      <el-form :model="ruleForm" :rules="rules" name="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
       

        <el-form-item label="所在大区" prop="serverId">
          <el-select v-model="ruleForm.serverId" placeholder="请选择所在大区" @change="handleServerChange">
            <el-option
                 v-for="item in serverList"
                  :key="item.serverId"
                  :label="item.serverName"
                  :value="item.serverId"
                ></el-option>
          </el-select>
        </el-form-item>

          <!-- <el-form-item label="角色名称" prop="roleName">
          <el-input v-model="ruleForm.roleName" placeholder="请输入角色名称"></el-input>
        </el-form-item> -->

        <el-form-item label="安全手机" prop="phone">
          <el-input v-model="ruleForm.phone"   
          autocomplete="off" placeholder="请输入安全手机号码"></el-input>
        </el-form-item>

        <el-form-item label="角色名称" prop="roleName">
          <el-select v-model="ruleForm.roleName" placeholder="请选择角色名称"  @click.native="getQueryRoles">
            <el-option
                 style="font-size: 16px;"
                 v-for="item in rolesList"
                  :key="item.roleName"
                  :label="item.roleName"
                  :value="item.roleName"
                ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="充值金额" prop="rechargeId">
          <el-select q
               v-model="ruleForm.rechargeId"
               :popper-append-to-body="false"
                placeholder="请选择充值档位">
            <el-option
                  v-for="item in productList"
                  :key="item.id"
                  :label="item.desc"
                  :value="item.id"
                ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

<!-- 
      立即充值图片 -->
      <div class="topup" @click="topup()"></div>
    
     <!-- <div class="topup"> 充值有问题等待修复</div> -->
      <div class="msg">
        <button :class="{ 'is-selected': isSelected }" @click="toggleSelection">
                {{ isSelected ? '' : '' }}
        </button>
            我同意
            <a @click="footerSkip(footer.userAgreement)">{{
              footer.userAgreement.title
          }}</a>
            {{ " | " }}
            <a @click="footerSkip(footer.privacyPolicy)">{{
              footer.privacyPolicy.title
            }}</a>
      </div>
 
    <div style="display: flex; align-items: center"  class="message-content">
        温馨提示:充值比例为1元=1000元宝当前只支持微信支付
        </div>

      </el-dialog>

      <!-- 微信二维码支付 -->
    <div id="voucherPay"  v-show="false">
  
    <el-dialog  class="voucher-count"  center width="80vw"  :visible.sync="voucherPayShow"  append-to-body>
      <div class="voucherPay">
      <p class="self-qr-desc">请扫以下二维码进行支付</p>
      <img :src="qrCodeImg" style="height: 150px;width:150px;padding-left: 13%;"/>
      <!-- 赋值金额 -->
      <div   style="color: red;" id="number">     </div>
           
      <div class="self-qr-footer">
        <img  src='../../../assets/image/pc/recharge/wxpay.jpg' alt /> <p>微信扫码</p>
        </div>
      </div>
      </el-dialog>
     
      </div>
  <!-- 微信二维码支付 -->

  </div>
</div>
</template>

<script>

import QRCode from "qrcode";
import utils from "../../../utils";
import { mapMutations } from "vuex";
import recharApi from '../../../api/testRechargeApi'

export default {
  props: {
   
  },
  data() {
    // 手机号校验
    let checkPhone = (rule, value, callback) => {
      var reg = /^1[3456789]\d{9}$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error("安全手机号码格式不正确"));
      }
    }
    return {
      isSelected: false,//选中事件
      testVoucherMobileShow:false,
      productList:[],
      serverList:[],
      rolesList:[],
      voucherPayShow:false,
      buttonCheck:'',
      elementId: 'initialId',
      // codeUrl:'weixin://wxpay/bizpayurl?pr=tWPuTqdz3',
      codeUrl:'',
      qrCodeImg: '',

      ruleForm: {
          appSource: "official",
          channelId: "official",
          deviceId: "4",
          payId: "302",
          playerId: "0",
          rechargeId:'',
          // rechargeId:'16',
          roleId: "0",
          serverId: '',
          // serverId: "7003",
          // p302:{phone:"", roleName:""},
          phone:"",
          roleName:"",
          p302:{"phone": "13522711267", "roleName": "模式"},
        
      },
   
   
      rules: {
        roleName: [
          { required: true, message: '请输入角色名称', trigger: 'blur' },
          { min: 1, max: 25, message: '长度在 1 到 25 个字符', trigger: 'blur' },
          { validator: this.noSpaces, trigger: 'blur' },
        ],
        serverId: [
          { required: true, message: '请选择所在大区', trigger: 'change' }
        ],
        rechargeId: [
          { required: true, message: '请选择充值金额', trigger: 'change' }
        ],
       phone: [
          { required: true, message: '请输入安全手机号码', trigger: 'blur' },
          { validator: this.noSpaces, trigger: 'blur' },
          //需要验证手机号格式
          { validator: checkPhone, trigger: "blur" },
        ],
        
      },

    };
    


  },

  computed: {
    footer() {
      return this.$config.footer;
    },

  },
  mounted() {
  
    // this.createQR(this.codeUrl)
    // this.getProductUrls(); // 获取充值金额列表链接
    this.getServerUrls(); // 获取所在大区
    // this.codeUrl()
    // this.topup(this.codeUrl)
  
  },
 
  methods: {
    noSpaces(rule, value, callback) {
      if (value.indexOf(' ') >= 0) {
        callback(new Error('输入值不能包含空格'));
      } else {
        callback();
      }
    },
    // submitForm(formName) {
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       alert('submit!');
    //     } else {
    //       console.log('error submit!!');
    //       return false;
    //     }
    //   });
    // },
    // resetForm(formName) {
    //   this.$refs[formName].resetFields();
    // },
    //关闭弹框
    close() {
      this.$emit("VoucherClose", false);
    },
    toggleSelection() {
      this.isSelected = !this.isSelected;
    },
    async footerSkip(item) {
      let { id, title, type } = item;
      this.$router.push({ path: "/detail", query: { id, title, type } });
    },
    async handleServerChange(serverId) {
      if (serverId) {
        await this.getProductUrls(serverId);
        this.ruleForm.rechargeId = '';
      } else {
        this.productList = [];
      }
      },
    async getProductUrls() {
      let ulrs = await recharApi.getProductUrls(); // 获取充值金额列表链接
      this.productList= ulrs.data;
    },
    async getServerUrls() {
      let ulrs = await recharApi.getServerUrls(); // 获取充值金额列表链接
      // console.log(ulrs.data);
      this.serverList= ulrs.data;
    },
    async  getQueryRoles() {
      // alert(1);
      console.log("getQueryRoles");
      let { phone } = this.ruleForm;
      let { serverId } = this.ruleForm;
      let params = { currentPhone: Number(phone), serverId:Number(serverId)};
      // const params=this.ruleForm
      let ulrs = await recharApi.getQueryRoles(params); // 获取角色列表
      this.rolesList= ulrs.data;
    },
    //充值方法
  createQR(codeUrl) {  

            let opts = {
            errorCorrectionLevel:"H",//容错级别
            type:"image/png",//生成的二维码类型
            quality:0.3,//二维码质量
            margin:5,//二维码留白边距
            width:300,//宽
            height:300,//高
            color: {
            dark:"#000",//前景色
            light:"#fff"//背景色
            }
            };
          
            QRCode.toDataURL(codeUrl, opts, (err, url) => {
            // console.log(err);
            //将生成的二维码路径复制给data的QRImgUrl
            // console.log("url".url);
            if (url === undefined) {
              // console.log("codeUrl111111");
            this.$message({
            type: 'error',
            message:"支付调起失败"
            // this.qrCode = url
            // this.QRShow = true

            })
          }
          this.qrCodeImg = url
          })
        // }
        // }
      },


      // 充值
   // 充值
   topup() {
      if (this.isSelected == true) {
        // 请求微信接口
        //表单验证
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            // 充值二维码部分
            const params = Object.assign({}, this.ruleForm)
            params.p302.roleName = params.roleName
            params.p302.phone = params.phone
            delete params.roleName
            delete params.phone
            let res = await recharApi.unifiedOrder(params);
            if (res.code == 200) {
              this.elementId = 'newId';
              // console.log(res.data.p302.codeUrl);
              // this.voucherPayNumber=res.data.rechargeId+''+"6元"
              this.voucherPayShow = true;
              this.createQR(res.data.p302.codeUrl);
            } else {
              if(res.code == 40002){
              this.$message({
                type: 'error',
                message: "用户信息有误！"
              })
            }
            }
          } else {
            return false;
          }
        });
      } else {
        this.$message({
          type: 'error',
          message: "用户协议未同意"
        })
      }
    },
  
  },


}
</script>

<style lang="scss" scoped>


.voucher-count{
  width:100%;
  // justify-content: center;
  // align-items: center;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  ::v-deep .el-dialog--center{
     border: 1px solid;
     border-radius: 2%;
    }

}
//充值选择表单区域

.self-demo-dialog {
  position: inherit;
  ::v-deep .el-form-item__label {
    position: relative;
  }
  ::v-deep .el-dialog {
    background-image: url('../../../assets/image/pc/recharge/bjmobile.png');
    background-size: 100% 100%;
    background-color: transparent;
    border-radius: 3%;
    -webkit-box-shadow: 0 1px 3px transparent;
    box-shadow: 0 1px 3px transparent;

    }
    ::v-deep .el-dialog_body{
  
      padding: 15px auto !important;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    // background-color: hsl(0, 99%, 0%);

    }
    ::v-deep .el-dialog__header {
      padding: 0px 10px 10px;
    }

  ::v-deep .el-form-item__label:before {
    display: inline-block;
    position: relative;
    top: 3px;
    left: -2px;
    content: '' !important;
    width: 14px;
    height: 16px;
    background: url(../../../assets/image/pc/recharge/lx.png) no-repeat !important;
    background-size: 14px 16px !important;
  }
  ::v-deep  .el-form {
      // min-width: 400px;
      }
  ::v-deep  .el-form-item__label {
        width: 100%;
        font-size: 16px;
        font-weight: 600;
        color: #502d07;
  }

   ::v-deep  .el-input:focus {
    font-size: 16px !important;

  }
  ::v-deep .el-dialog__close {
    color: #502d07;
     font-size: 20px;
     line-height: 4px;
  }
  // ::v-deep  .el-input--suffix {
  //       width: 300px;

  // }
  // .el-select-dropdown{
  //   width: 100%;
  //       font-size: 16px;
  //       font-weight: 600;
  //       color: #502d07;
  // }
   
  //   ::v-deep  .el-input__inner {
  //       height: 40px;
  //       color: #000000;
  //       font-size: 10px;
  //     }  
  // ::v-deep  .el-input {
  //       width: 100%;
  //       height: 40px;
  //       background-color: #fbf8f1;
  //       border-radius: 8px;
  //     }

}


//调整弹框的
    ::v-deep .el-dialog__body {
      padding: 15px auto !important;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
    }

    // 二维码支付部分
    .self-qr-desc {
      font-size: 16px;
    }

    .self-qr-footer {
      display: flex;
      align-items: center;

      img {
        width: 20px;
        height: 16px;
        display: block;
        border: 1px red solid;
      }

      p {
        font-size: 16px;
        margin-left: 5px;
      }
    }
    .voucher-title {
          font-size:24px;
          color: #77420c;
          font-weight:800;
          margin-bottom: 4%;
        }

    .message-content{
  
      height: 5%;
      flex: content;
      font-size: 11px;
      text-align: center;
      color: red;
      font-weight: bold;
    }

    .topup {
      width:100px;
      height: 32px;
      text-align: center;
      line-height: 35px;
      margin: 4px auto;
      background-size: 100% 100%;
      color: #eac46c;
      cursor: pointer;
      background-image: url('../../../assets/image/pc/recharge/anpc.png'); /* 背景图片路径 */
    }
 
    .noimg {
        display: flex;
        align-items: center;
        justify-content: center;
        align-items: center;
        // width: 20px;
        // height: 20px;
        margin-right: 5px;
        border-radius: 5px;
        img {
          width: 18px;
          height: 12 px;
        }
      }
      .msg {
      font-size: 12px;
         font-weight: bold;
        color:  #502d07;
        margin-bottom: 1%;
        a {
          text-decoration: underline;
          cursor: pointer;
        }
        button {
        padding: 2%;
        background-color: #fbf8f1;
        border:1px solid #fbf8f1;;
        width: 15px;
        height: 15px;
        border-radius: 15%; 
      }
      }
      .is-selected {
        // display: inline-block;
        // position: relative;
        // top: 3px;
        // left: -2px;
        // content: '' !important;
        width: 16px;
        height: 18px;
        background: url(../../../assets/image/pc/recharge/check.png) no-repeat !important;
        background-size: 12px 10px !important;
 
    }

//支付模块
.voucherPay{
  width: 200px;
  height:200px;
  margin: auto;


}
// ::v-deep .el-dialog__body {
//  padding: 15px auto !important;
//  display: flex;
//  justify-content: center;
//  flex-direction: column;
//  align-items: center;
//  z-index: 2000;
// }

    .self-qr-desc {
    font-size: 16px;
    text-align: center;
    }
    .self-qr-number{
      font-size: 12px;
    text-align: center;
    color: red;
    }
    .self-qr-footer {
    display: flex;
    align-items: center;
    width: 60%;
    height: 18%;
    margin: auto;
    img {
    width: 30px;
    height: 25px;
    display: block;
    border: 1px #ffff  solid;
    }
    p {
    font-size: 16px;
    margin-left: 5px;
    }
    }


</style>
